import { variantProvider } from '@/app'
import { Icon, Text, View } from '@/components'

export function CompleteLessonBadge() {
  return (
    <View variants={['fullWidth', 'center']} style={styles.progress}>
      <View variants={['bg:neutral1', 'row', 'border-radius:small', 'padding:1.5', 'center']} style={styles.content}>
        <View variants={['bg:primary3', 'border-radius:tiny', 'padding:1.5']}>
          <Icon debugName="modal done star" name="star-fill" variants={['iconSize:1', 'neutral10']} />
        </View>
        <Text variants={['h3', 'marginLeft: 2']} text="100%" />
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  t => ({
    progress: {
      ...t.spacing.marginTop(1),

      [t.media.down('small')]: {
        bottom: 0,
        left: '50%',
        width: '100vw',
        ...t.spacing.marginTop(0),
        zIndex: 100
      }
    },
    content: {
      width: 134,
      height: 72
    }
  }),
  true
)
